export enum iconClass {
    DASHBOARD = 'fas fa-tachometer-alt',
    CHARGES_SWAP = 'fas fa-arrow-right-arrow-left',
    PREINVOICE_CARRIER = 'fas fa-hourglass',
    INVOICE = 'fas fa-file-invoice-dollar',
    DELIVERIES = 'fas fa-truck-droplet',
    PLANNING = 'fa-regular fa-calendar-days',
    TANKS = 'fas fa-fill',
    GENERAL_DOCUMENTS = 'fas fa-file',
    SETTINGS = 'fas fa-gear',
    CARRIERS = 'fas fa-truck',
    USERS = 'fas fa-users',
    CLIENTS = 'fas fa-user',
    STATIONS = 'fas fa-warehouse',
    TERMINALS = 'fas fa-flag',
    LOG_OUT = 'fas fa-unlock',
    LAB = 'fas fa-flask',
    BAR = 'fas fa-signal',
    PIE = 'fas fa-chart-pie',
    CLASS = 'fas fa-layer-group',
    CLOSE = 'fas fa-window-close'
}
